import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withGenericConfig } from "/contexts/generic-config-context";
import { ACCESSIBILITY_STATEMENT_LINK } from "constants/links";
import AccessibilityIcon from "static/svg/accessibility/accessibility_icon6.svg";
import { StyledAccessibilityStatementLinkComponent } from "./accessibility-statement-link-component.scss";
const AccessibilityStatementLinkComponent = (props)=>{
    return /*#__PURE__*/ _jsxs(StyledAccessibilityStatementLinkComponent, {
        className: "accessibilty-statement-link-component",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "accessibility-icon-wrapper",
                children: /*#__PURE__*/ _jsx(AccessibilityIcon, {
                    className: "accessibility-icon"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "accessibility-link-wrapper",
                children: /*#__PURE__*/ _jsx("a", {
                    href: ACCESSIBILITY_STATEMENT_LINK,
                    className: "accessibility-link",
                    children: props.translate("footer.accessibiltyStatement")
                })
            })
        ]
    });
};
export default withGenericConfig(AccessibilityStatementLinkComponent);
